import customSelect from 'custom-select'
import './../../styles/modules/plugins/custom-select.scss'

const selectElements = document.querySelectorAll('.contact-form select')
selectElements.forEach(select => {
  customSelect(select)
})